<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            max-width="500"
            scrollable
        >
            <v-card>
                <v-card-text>
                    <v-treeview
                            v-model="selected"
                            :active.sync="active"
                            :open.sync="open"
                            :selectable="!single"
                            :activatable="single"
                            :items="organizationalCharts"
                            color="teal"
                            selected-color="teal"
                            :selection-type="'leaft'"
                            open-all
                            @input="save"
                            @update:active="save"
                    >
                        <template v-slot:prepend="{ open }">
                            <v-icon>
                                {{ open ? "mdi-folder-open" : "mdi-folder" }}
                            </v-icon>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-select
                v-model="selected"
                :items="organizationalChartStore.organizationalChartsSelect"
                item-text="name"
                item-value="id"
                :label="label"
                prepend-inner-icon="mdi-circle-double"
                multiple
                :chips="!single"
                :deletable-chips="!single"
                :clearable="!readonly"
                :loading="loading"
                small-chips
                :menu-props="{ maxHeight: 0 }"
                outlined
                :color="inputColor"
                :background-color="backgroundColor"
                dense
                hide-details="auto"
                :rules="rules"
                @click="dialog = true"
        >
        </v-select>
        <input type="hidden"/>
    </div>
</template>

<script>
import {onMounted, ref, watch} from "vue";
import {useOrganizationalChartStore} from "@/stores/OrganizationalChart";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: Array,
        label: String,
        rules: Array,
        single: Boolean,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();
        const organizationalChartStore = useOrganizationalChartStore();

        const modal = ref(false);
        const loading = ref(false);
        const dialog = ref(false);
        const selected = ref([]);
        const active = ref([]);
        const open = ref([0]);
        const organizationalCharts = ref([]);

        function findHeaders() {
            loading.value = true;
            axios.get('/organizationalCharts/header', {
                params: {
                    getImage: false,
                },
            }).then((response) => {
                organizationalCharts.value = response.data;
                findAll();
            });
        }

        function findAll() {
            axios.get('/organizationalCharts').then((response) => {
                organizationalChartStore.setOrganizationalChartsSelect(response.data);
            }).finally(() => {
                loading.value = false;
            });
        }

        function save() {
            if (props.single) {
                emit("input", active.value.length > 0 ? active.value[0] : null);
                dialog.value = false;
            } else {
                emit("input", selected.value);
            }
            emit("changed");
        }

        function clear() {
            selected.value = [];
            emit("input", null);
        }

        watch(() => props.value, () => {
            selected.value = props.value;
        }, {immediate: true});

        onMounted(() => {
            findHeaders();
        });

        return {
            organizationalChartStore,
            modal,
            inputColor,
            backgroundColor,
            loading,
            dialog,
            selected,
            active,
            open,
            organizationalCharts,
            save,
            clear
        }
    },
};
</script>